export default "/static/baf88e224766ff3ef06b01b071d6a976593a2da1/frontend/da679ea2bc45412fd43089fd524a5e8e.svg";